import { combineReducers } from "redux";
import { IAction } from "src/store";
import { augmentReducer } from "src/store/utils";
import { manageMetricsReducer } from "src/store/manageMetric";
import { augmentedAllOrgMetricsReducer } from "src/store/allOrg";
import { pinsReducer, searchReducer, homeParentConstants } from "./redux";
import { PinnedMetricsReducerState, IHomeReducerState } from "./types";

const initialState = {
  loadMorePending: false,
  chartsDataPending: false,
};

const parentReducer = (state = initialState, { type, payload }: IAction<symbol, any>) => {
  switch (type) {
    case homeParentConstants.get("LOAD_MORE_PENDING"):
      return { ...state, loadMorePending: payload };
    case homeParentConstants.get("FETCHING_HOME_DATA"):
      return { ...state, chartsDataPending: payload };
    default:
      return state;
  }
};

const pinnedMetricsReducer = augmentReducer<PinnedMetricsReducerState, IAction<symbol, any>>(parentReducer)({
  metrics: pinsReducer,
  search: searchReducer,
  manageMetrics: manageMetricsReducer,
});

export default combineReducers<IHomeReducerState>({
  pinnedMetrics: pinnedMetricsReducer,
  allOrgMetrics: augmentedAllOrgMetricsReducer,
});
